'use strict';

var attr = {};
window.attr = attr;

function setAttr(name, value) {
    attr[name] = value;
}

function getAttr(name) {
    return attr[name];
}

function resetAttr() {
    // Eigenschaften am bestehenden Objekt loeschen (Referenz bleibt stabil),
    // damit window.attr nicht auf ein verwaistes altes Objekt zeigt.
    Object.keys(attr).forEach((k) => delete attr[k]);
}

export {
    getAttr,
    setAttr,
    resetAttr
}